// ─────────────────────────────────────────────────────────────────────────────
// Regras de fatura de cartão de crédito.
//
// Uma compra no cartão NÃO sai do bolso no dia da compra: ela entra na fatura
// que ainda está aberta e é paga no vencimento dessa fatura. Por isso o app
// guarda em `tx.date` o VENCIMENTO DA FATURA (é assim que o extrato do cartão,
// o calendário e as previsões agrupam os lançamentos) e em `tx.purchaseDate` a
// data real da compra.
//
// A mesma regra está espelhada em `functions/index.js` (lançamentos que chegam
// pelo WhatsApp/Telegram) — se mudar aqui, mudar lá também.
// ─────────────────────────────────────────────────────────────────────────────

export function calcCardDueDate(card, purchaseDate) {
  const [py, pm, pd] = String(purchaseDate || '').split('-').map(Number);
  const base = (py && pm && pd) ? new Date(py, pm - 1, pd) : new Date();
  const dueDay   = Number(card?.dueDay)   || 15;
  const closeDay = Number(card?.closeDay) || 1;

  let year  = base.getFullYear();
  let month = base.getMonth();

  // Compra no dia do fechamento ou depois → já entra na fatura seguinte
  if (base.getDate() >= closeDay) month += 1;
  // Vencimento antes/igual ao fechamento → o pagamento cai um mês após fechar
  // (ex: fecha dia 25, vence dia 5 → vence no mês seguinte ao fechamento)
  if (dueDay <= closeDay) month += 1;

  year += Math.floor(month / 12);
  month = ((month % 12) + 12) % 12;

  // Vencimento dia 31 num mês de 30 dias vira o último dia do mês
  const lastDay = new Date(year, month + 1, 0).getDate();
  const mm = String(month + 1).padStart(2, '0');
  const dd = String(Math.min(dueDay, lastDay)).padStart(2, '0');
  return `${year}-${mm}-${dd}`;
}

// '2026-08-05' → '05/08/2026' (sem passar por new Date, que puxa fuso)
export function fmtDateBR(iso) {
  return String(iso || '').split('-').reverse().join('/');
}
